#import "../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query PaymentInvoiceTransactionTypes {
  invoiceTransactionTypes(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      transactionType
      layoutType
    }
  }
  companyCurrencies {
    nodes {
      id
      name
      isoCode
    }
  }
  companyBusinessUnits {
    nodes {
      id
      name
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      userDepartment {
        _isUserAssigned
      }
    }
  }
  tax1099T4Types {
    nodes {
      id
      tax1099T4Type
      abbreviation
    }
  }
  productionIncentives {
    nodes {
      id
      incentiveType {
        incentiveType
      }
    }
  }
  invoiceDistributionStatusTypes {
    nodes {
      id
      statusType
      isExplanationRequired
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
  companies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyCorporatePeriods(
    filter: { isEntryAllowed: { equalTo: true } }
    orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]
  ) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
  companyCurrencies {
    nodes {
      id
      name
    }
  }
  companyCardHolders {
    nodes {
      id
      cardFullName
      cardNumber
      departmentId
    }
  }
  cardHolders {
    nodes {
      cardFullName
      cardNumber
      id
      departmentId
    }
  }
  invoiceUsers {
    nodes {
      userId
      userName
    }
  }
  statusTypes(
    orderBy: ID_ASC
    filter: { isApprovalHintOverride: { equalTo: true } }
  ) {
    nodes {
      id
      statusType
    }
  }
}
